const statuses = {
  ON_DEMO: 1,
  FINISHED_DEMO: 2,
  WAITING_CUSTOMIZATION: 3,
  REQUEST_SENT: 4,
  SITE_SENT: 5,
  SITE_AVAILABLE: 6,
  SITE_CONFIRMED: 7,
};

// REQUESTED: 1,
// REQUEST_IN_ANALYSES: 2,

const texts = {
  [statuses.ON_DEMO]: 'Em demonstração',
  [statuses.FINISHED_DEMO]: 'Demonstração finalizada',
  [statuses.WAITING_CUSTOMIZATION]: 'Aguardando customização',
  [statuses.REQUEST_SENT]: 'Pedido de envio',
  [statuses.SITE_SENT]: 'Site enviado',
  [statuses.SITE_AVAILABLE]: 'Site disponível',
  [statuses.SITE_CONFIRMED]: 'Site confirmado pelo profissional',
};

// [statuses.REQUESTED]: 'Em demonstração',
// [statuses.REQUEST_IN_ANALYSES]: 'Demonstração finalizada',

export default statuses;

export const getText = (status) => texts[status];